import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { MyHttpClient } from '../http-client';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ViewCampaignsService {

  fetchCampaignsUrl = environment.server + '/api/get/campaigns/v1'
  fetchEventsUrl = environment.server + '/api/get/events/v1'
  deactivateRuleUrl = environment.server + '/api/deactivateRule'
  rulePerformanceUrl = environment.server + '/api/performance'
  constructor(private http: MyHttpClient) { }
  
  fetchCampaignsData(payload) {
    return this.http.post(this.fetchCampaignsUrl, payload).pipe(catchError(this.handleError));
  }

  fetchEventsData() {
    return this.http.get(this.fetchEventsUrl).pipe(catchError(this.handleError));
  }

  deactivateRule(ruleId) {
    const payload = {rid : ruleId}
    return this.http.put(this.deactivateRuleUrl, payload).pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    // return an observable with a user-facing error message
    return throwError(error);
    // return {};
  }
}
